import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';

import { prepareToOpenNewOrderModal } from '../../../../../../store/orders/edit-order/edit.order.actions';
import { useTrackWorkflow, WorkflowSteps } from '../../../../../../tracking/use-workflow-tracking';
import { EventSourceStrings, Workflows } from '../../../../../../tracking/tracking-constants';
import { sources as MarketplaceConnectionSources, useTrackMarketplaceConnection } from '../../../../../settings/stores/tracking-events';
import { MarketplaceSelector } from './marketplace-selector';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';
import { useOrderCSVImportContext } from '../../../../../../components/order-import/order-import-context';

import { messages } from '../../messages';
import style from '../../onboard-cards.module.less';

export const OrderImportCardFooterIncomplete = () => {
  const { isPopup } = useHomePageOnboardContext();

  const dispatch = useDispatch();
  const { openCSVImport } = useOrderCSVImportContext();
  const [selectedMarketplace, setSelectedMarketplace] = useState(undefined);
  const [marketplaceSelectorOpen, setMarketplaceSelectorOpen] = useState(false);

  const onClickCreateManualOrder = useCallback(() => dispatch(prepareToOpenNewOrderModal()), [dispatch]);

  const trackMarketplaceConnection = useTrackMarketplaceConnection();
  const launchMarketplaceSelectionModal = useCallback(() => {
    trackMarketplaceConnection(WorkflowSteps.START, {
      source: isPopup ? MarketplaceConnectionSources.GETTING_STARTED_GUIDE : MarketplaceConnectionSources.HOME_PAGE_ONBOARDING_STEP,
    });
    setSelectedMarketplace(undefined);
    setMarketplaceSelectorOpen(true);
  }, [isPopup, trackMarketplaceConnection]);

  const trackOrderImport = useTrackWorkflow(Workflows.ORDER_IMPORT_FLOW);
  const onClickImportCSV = useCallback(() => {
    trackOrderImport(WorkflowSteps.START, {
      source: isPopup ? EventSourceStrings.GETTING_STARTED_GUIDE_IMPORT_ORDERS : EventSourceStrings.HOME_PAGE_ONBOARDING_STEP,
    });
    openCSVImport();
  }, [isPopup, openCSVImport, trackOrderImport]);
  return (
    <>
      <FlexRow className={style['footer-row']}>
        <Button className={style['footer-row-group']} onClick={launchMarketplaceSelectionModal} theme='primary'>
          <FormattedMessage {...messages.launchMarketplaceCUI} />
        </Button>
        <FlexRow className={classnames(style['footer-row'], style['footer-row-group'])}>
          <Button
            className={classnames(style['additional-action-button'], style['footer-row-group'])}
            onClick={onClickImportCSV}
            theme='tertiary'
          >
            <FormattedMessage {...messages.importOrdersCSV} />
          </Button>
          <Button
            className={classnames(style['additional-action-button'], style['footer-row-group'])}
            onClick={onClickCreateManualOrder}
            theme='tertiary'
          >
            <FormattedMessage {...messages.create} />
          </Button>
        </FlexRow>
      </FlexRow>
      <MarketplaceSelector
        marketplaceSelectorOpen={marketplaceSelectorOpen}
        selectedMarketplace={selectedMarketplace}
        setMarketplaceSelectorOpen={setMarketplaceSelectorOpen}
        setSelectedMarketplace={setSelectedMarketplace}
      />
    </>
  );
};
